module.exports = __webpack_public_path__ + "img/logos_overview-emptystate.39a0e304.svg";